import { useState } from 'react'
import { Box, Button, Typography } from '@material-ui/core'

import * as service from 'service'

const ZitadelVerifyStatus = ({
  zitadelIdpActivated,
  ssoCorporateGroup,
  refresh,
  statusVerified,
  setStatusVerified,
}) => {
  const [isVerifying, setIsVerifying] = useState(false)
  const [updating, setUpdating] = useState(false)

  const verifyStatus = async () => {
    try {
      setIsVerifying(true)
      const response =
        await service.dponet.ssoCorporateGroups.verifyZitadelConnection({
          ssoCorporateGroupId: ssoCorporateGroup?.id,
        })

      setStatusVerified(response?.data?.verified || false)
      if (response?.data?.verified) {
        refresh()
      }
    } catch (error) {
      setStatusVerified(false)
    } finally {
      setIsVerifying(false)
    }
  }

  const forceZitadelUpdate = async () => {
    try {
      setUpdating(true)
      await service.dponet.ssoCorporateGroups.forceZitadelUpdate({
        ssoCorporateGroupId: ssoCorporateGroup?.id,
      })
    } finally {
      setUpdating(false)
    }
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      my={2}
      alignItems="flex-start"
      gridGap={4}
    >
      <Typography
        variant="h6"
        gutterBottom
        color={statusVerified ? 'primary' : 'error'}
      >
        {statusVerified
          ? 'Provedor de Identidade verificado com sucesso!'
          : 'Provedor de Identidade não verificado. Clique no botão para verificar a conexão.'}
      </Typography>
      <Box display="flex" gridGap={4}>
        <Button
          variant="contained"
          color="primary"
          onClick={verifyStatus}
          disabled={!ssoCorporateGroup?.id || isVerifying || statusVerified}
        >
          {isVerifying ? 'Verificando' : 'Verificar'} Provedor de Identidade
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={forceZitadelUpdate}
          disabled={updating || (!zitadelIdpActivated && !statusVerified)}
        >
          Forçar atualização do Provedor de Identidade
        </Button>
      </Box>
    </Box>
  )
}

export default ZitadelVerifyStatus
